module.exports = __webpack_public_path__ + "img/icon-home-re-06.d88dd9db.jpg";